import { LinkedinLogo, ArrowSquareOut } from "@phosphor-icons/react";

const COLOR_CLASS = {
  linkedin: "bg-linkedin text-white border-linkedin hover:bg-linkedin-hover",
  terracotta: "bg-terracotta text-white border-terracotta hover:bg-terracotta-hover",
  saffron: "bg-saffron/20 text-saffron-hover border-saffron hover:bg-saffron/35",
  teal: "bg-teal/15 text-teal border-teal hover:bg-teal/25",
};

export const ExternalProfiles = ({ profiles = [], compact = false }) => {
  if (!profiles.length) return null;
  return (
    <div
      className={`flex flex-wrap gap-2 ${compact ? "" : "mt-4"}`}
      data-testid="external-profiles"
    >
      {profiles.map((p) => {
        const cls = COLOR_CLASS[p.color] || COLOR_CLASS.terracotta;
        const Icon = p.color === "linkedin" ? LinkedinLogo : ArrowSquareOut;
        return (
          <a
            key={p.label}
            href={p.url}
            target="_blank"
            rel="noreferrer"
            className={`inline-flex items-center gap-2 px-3.5 py-2 border text-xs font-mono uppercase tracking-wider font-medium transition-all duration-200 hover:-translate-y-[1px] ${cls}`}
            data-testid={`external-${p.label.toLowerCase().replace(/\s+/g, "-")}`}
          >
            <Icon size={14} weight={p.color === "linkedin" ? "fill" : "bold"} />
            {p.label}
          </a>
        );
      })}
    </div>
  );
};

export default ExternalProfiles;
